export default "__VITE_ASSET__893tHtTs__"